import { forwardRef } from 'react';
import { LuPlus } from 'react-icons/lu';
import type { AgentApiCompaniesSummaryItem } from '@/types/serializers';

type Props = {
  companies: AgentApiCompaniesSummaryItem[];
  onSelectCompany: (id: number, name: string) => void;
  onScroll?: () => void;
  isLoadingMore?: boolean;
  /**
   * 新規作成候補を末尾に表示するための入力テキスト。
   * 非空の場合のみ「『<inputText>』を新規作成」候補を末尾に表示する。
   */
  inputText?: string;
  /** 新規作成候補を選択したときのコールバック */
  onCreateNew?: (name: string) => void;
};

const CandidateCompanyList = forwardRef<HTMLDivElement, Props>(
  ({ companies, onSelectCompany, onScroll, isLoadingMore, inputText, onCreateNew }, ref) => {
    const showCreateNew = Boolean(inputText?.trim()) && onCreateNew != null;

    return (
      <div
        ref={ref}
        onScroll={onScroll}
        className="max-h-[480px] w-[350px] overflow-hidden overflow-y-auto rounded bg-white shadow-[0px_0px_12px_0px_#00000033]"
      >
        {companies.map((c) => {
          return (
            <div
              key={c.id}
              className="flex h-xxl cursor-pointer items-center px-2 text-sm hover:bg-gray"
              onClick={() => onSelectCompany(c.id, c.name)}
            >
              {c.name}
            </div>
          );
        })}
        {isLoadingMore && (
          <div className="flex h-xxl items-center justify-center text-sm text-gray-500">
            読み込み中...
          </div>
        )}
        {showCreateNew && (
          <button
            type="button"
            className="flex h-xxl w-full cursor-pointer items-center gap-1.5 border-t border-gray-200 px-2 text-left text-sm font-medium text-primary hover:bg-gray"
            onClick={() => onCreateNew!(inputText!.trim())}
          >
            <LuPlus className="size-4 shrink-0" />
            <span>「{inputText!.trim()}」を新規作成</span>
          </button>
        )}
      </div>
    );
  }
);

CandidateCompanyList.displayName = 'CandidateCompanyList';

export default CandidateCompanyList;
